import React, { HTMLAttributes } from 'react';

import { Container } from './styles';

type ToggleProps = HTMLAttributes<HTMLDivElement> & {
  firstText: string;
  secondText: string;
  checked: boolean;
  onToggle(value: boolean): void;
};

const Toggle: React.FC<ToggleProps> = ({
  firstText,
  secondText,
  checked,
  onToggle,
  ...rest
}) => {
  return (
    <Container isChecked={checked} {...rest}>
      <div onClick={() => onToggle(false)}>{firstText}</div>
      <span />
      <div onClick={() => onToggle(true)}>{secondText}</div>
    </Container>
  );
};

export default Toggle;
